import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function Hero({ title, subtitle, image, ctaText, ctaLink }) {
  return (
    <div className="flex flex-col sm:relative sm:block isolate overflow-hidden bg-[#133b54] sm:py-24 md:py-32 lg:py-36 sm:min-h-[550px]">
      
      {/* Mobile Image Section (only visible on mobile < sm) */}
      <div className="block sm:hidden h-64 w-full relative">
        <img
          src={image}
          alt=""
          className="h-full w-full object-cover object-center"
        />
      </div>

      {/* Mobile Text Section (only visible on mobile < sm) */}
      <div className="block sm:hidden bg-gray-50 px-6 py-12 text-center">
        <motion.h1 
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-2xl font-extrabold tracking-tight text-gray-900 uppercase"
        >
          {title}
        </motion.h1>
        <motion.p 
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-4 text-base leading-7 text-gray-600 font-medium"
        >
          {subtitle}
        </motion.p>
        <motion.div 
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-6 flex items-center justify-center"
        >
          <Link
            to={ctaLink}
            className="w-full rounded-none bg-orange-500 px-8 py-4 text-sm font-semibold text-white hover:bg-orange-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-500 transition-all transform hover:-translate-y-1 hover:shadow-xl duration-200 uppercase text-center"
          >
            {ctaText}
          </Link>
        </motion.div>
      </div>

      {/* Desktop Layout (only visible on sm and up) */}
      {/* Image: Absolute background on sm and up */}
      <div className="hidden sm:block absolute inset-0 -z-10 h-full w-full">
        <img
          src={image}
          alt=""
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/10" />
      </div>
      
      {/* Content wrapper for sm and up */}
      <div className="hidden sm:flex mx-auto max-w-7xl px-6 lg:px-8 w-full justify-center relative z-10">
        {/* Box styling on desktop */}
        <div className="w-full max-w-2xl text-center sm:bg-white/80 sm:backdrop-blur-md sm:p-12 sm:border sm:border-slate-200/50 sm:shadow-2xl">
          <motion.h1 
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-3xl font-extrabold tracking-tight sm:text-[#1e335e] sm:text-3xl md:text-4xl lg:text-5xl uppercase"
          >
            {title}
          </motion.h1>
          <motion.p 
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mt-4 sm:mt-6 text-base sm:text-lg md:text-xl leading-7 sm:leading-8 sm:text-slate-700 font-medium"
          >
            {subtitle}
          </motion.p>
          <motion.div 
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="mt-8 sm:mt-10 flex items-center justify-center"
          >
            <Link
              to={ctaLink}
              className="w-full sm:w-auto rounded-none bg-orange-500 px-8 py-4 text-sm font-semibold text-white hover:bg-orange-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-500 transition-all transform hover:-translate-y-1 hover:shadow-xl duration-200 uppercase text-center"
            >
              {ctaText}
            </Link>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
